module.exports = __webpack_public_path__ + "static/media/YF34_2.ed3b39bc.jpg";